var Common = require( "./Common" );
var CommonGame = require( "./CommonGame" );


//===================================================
//
// Constructor
//
//===================================================

function SavedData()
{
	var assetManager = P3.AssetManager.instance;

	/**
	 * @type {String}
	 * @const
	 */
	this.SAVE_NAME = "customer_focus";
	this.SAVE_VERSION = "0.0.18";
	this.SAVE_SEED = "y5k0Eo6R177mUkb";

	/**
	 * @type {Boolean}
	 */
	this._isToolTutorial = true;
	this._isDrawTutorial = true;
	this._isPaletteTutorial = true;
}
module.exports = SavedData;


//===================================================
//
// Public
//
//===================================================

SavedData.prototype.init = function()
{	
	if ( !window.localStorage[ this.SAVE_NAME + "_" + this.SAVE_VERSION ] )
	{
		//console.log( 'reset' );
		this.reset();
		this.save();
	}
	else
	{
		//console.log( 'load' );
		this.load();
	}
};

SavedData.prototype.reset = function()
{
	this._isToolTutorial = true;
	this._isDrawTutorial = true;
	this._isPaletteTutorial = true;
};

SavedData.prototype.load = function()
{
	var data = window.localStorage[ this.SAVE_NAME + "_" + this.SAVE_VERSION ];
	data = JSON.parse( data );

	this._isToolTutorial 			= data.isToolTutorial;
	this._isDrawTutorial 			= data.isDrawTutorial;
	this._isPaletteTutorial 		= data.isPaletteTutorial;
};

SavedData.prototype.save = function()
{
	//console.log( 'save' );
	var data = {};
	data.isToolTutorial 		= this._isToolTutorial;
	data.isDrawTutorial 		= this._isDrawTutorial;
	data.isPaletteTutorial 		= this._isPaletteTutorial;

	var json = JSON.stringify( data );
	data.hash = md5( json + this.SAVE_SEED );

	window.localStorage[ this.SAVE_NAME + "_" + this.SAVE_VERSION ] = JSON.stringify( data );
};


//===================================================
//
// Getters / Setters
//
//===================================================
	
Object.defineProperty(
	SavedData.prototype, 
	"isToolTutorial", 
	{ 	get: function() { return this._isToolTutorial; },
		set: function( a ) { this._isToolTutorial = a; } } );

Object.defineProperty(
	SavedData.prototype, 
	"isDrawTutorial", 
	{ 	get: function() { return this._isDrawTutorial; },
		set: function( a ) { this._isDrawTutorial = a; } } );
		
Object.defineProperty(
	SavedData.prototype, 
	"isPaletteTutorial", 
	{ 	get: function() { return this._isPaletteTutorial; },
		set: function( a ) { this._isPaletteTutorial = a; } } );